import React from "react";

const ReadmoreBtn = ({ theme }) => {
  return (
    <button
      className={`${
        theme === "dark"
          ? "border border-[#1055EA] text-white hover:bg-black hover:border-opacity-80"
          : "border border-lightTextDesignColor text-darkBgColor hover:text-lightTextDesignColor hover:border-opacity-80"
      } text-xl px-6 py-3 text-center transition-hover duration-300 cursor-pointer`}
    >
      Read More
    </button>
  );
};

export default ReadmoreBtn;
